import { useQuery } from '@apollo/react-hooks';
import { get } from 'helpers/utilities';

import jobBenefitsQuery from '../queries/jobBenefits';

const useJobBenefits = locationSlug => {
  const query = jobBenefitsQuery(locationSlug);
  const { data } = useQuery(query);

  return get(data, 'entry.jobBenefitsSelector', []);
};

export default useJobBenefits;
